<template>
    <div>
        <div class="row" style="padding-right:15px; padding-left:15px;">
            <div class="mr-auto">
                <button title="Ajouter une donnée" class="btn btn-custom" @click="onAction('add-item',data[0])"
                        v-show="isEditable"><i class="fas fa-plus"></i> Ajouter une donnée
                </button>
            </div>
            <div class="ml-auto">
                <filter-bar></filter-bar>
            </div>
        </div>
        <br>

        <div class="table-responsive">
            <vuetable ref="vuetable"
                      :api-mode="false"
                      :fields="fields"
                      :per-page="perPage"
                      :data-manager="dataManager"
                      :repo="repo"
                      :is-editable="isEditable"
                      pagination-path="pagination"
                      @vuetable:pagination-data="onPaginationData"
                      class="table"
            >
                <div slot="actions" slot-scope="props" v-show="isEditable === 1">
                    <div class="custom-actions">
                        <button class="ui basic button btn-custom btn"
                                title="Editer la donnée"
                                @click="onAction('edit-item', props.rowData, props.rowIndex)">
                            <i class="far fa-edit"></i>
                        </button>
                        <button class="ui basic button btn-danger btn"
                                title="Supprimer la donnée"
                                @click="onAction('delete-item', props.rowData, props.rowIndex)">
                            <i class="far fa-times-circle"></i>
                        </button>
                        <button class="ui basic button btn-secondary btn" v-show="repo === 'officer'"
                                title="Réinitialiser le mot de passe de l'officier"
                                @click="onAction('reset-password', props.rowData, props.rowIndex)">
                            <i class="fas fa-unlock-alt"></i>
                        </button>
                    </div>
                </div>

                <div slot="active" slot-scope="props">
                    <span v-if="props.rowData.active" class="badge badge-pill badge-success">Actif</span>
                    <span v-else class="badge badge-pill badge-danger">Inactif</span>
                </div>

            </vuetable>
        </div>

        <div class="row col-lg-12 pr-0">
            <div class="mr-auto">
                <vuetable-pagination-info ref="paginationInfo"
                                          class="alert alert-info tablePagination"
                                          info-template="Affichage de {from} à {to} sur {total} éléments"
                                          no-data-template="Aucun élément"
                ></vuetable-pagination-info>
            </div>
            <div class="ml-auto pr-0">
                <vuetable-pagination ref="pagination"
                                     @vuetable-pagination:change-page="onChangePage"
                                     :css="css.pagination"
                ></vuetable-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    import Vuetable from 'vuetable-2';
    import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
    import VuetablePaginationInfo from 'vuetable-2/src/components/VuetablePaginationInfo';
    import FilterBar from './FilterBar';

    export default {
        name: "datatable",
        components: {
            Vuetable,
            VuetablePagination,
            VuetablePaginationInfo,
            FilterBar
        },
        props: {
            data: Array,
            fields: Array,
            perPage: Number,
            repo: String,
            isEditable: Number
        },
        data() {
            return {
                moreParams: {},
                css: {
                    pagination: {
                        activeClass: 'btn-custom',
                        disabledClass: 'disabled',
                        pageClass: 'btn btn-border',
                        linkClass: 'btn btn-border',
                        icons: {
                            first: '',
                            prev: '',
                            next: '',
                            last: '',
                        }
                    }
                }
            }
        },
        methods: {
            /**
             * Gestion de la pagination
             * @param paginationData
             */
            onPaginationData(paginationData) {
                this.$refs.pagination.setPaginationData(paginationData);
                this.$refs.paginationInfo.setPaginationData(paginationData);
            },
            /**
             * Gestion du changement de page
             * @param page
             */
            onChangePage(page) {
                this.$refs.vuetable.changePage(page);
            },
            /**
             * Gestion des données
             *
             * @param sortOrder
             * @param pagination
             * @returns {{pagination: *|{total, per_page, current_page, last_page, next_page_url, prev_page_url, from, to}, data: Array}}
             */
            dataManager(sortOrder, pagination) {
                if (this.data.length < 1) return [];

                let local = this.data;


                // sortOrder can be empty, so we have to check for that as well
                if (sortOrder.length > 0) {
                    local = _.orderBy(
                        local,
                        sortOrder[0].sortField,
                        sortOrder[0].direction
                    );
                }

                // Création de la pagination
                pagination = this.$refs.vuetable.makePagination(
                    local.length,
                    this.perPage
                );
                let from = pagination.from - 1;
                let to = from + this.perPage;

                return {
                    pagination: pagination,
                    data: _.slice(local, from, to)
                };
            },
            onAction(action, data) {
                this.$emit('action', {data, action});
            }
        },
        watch: {
            /**
             * Rafraichit la table si les données changent
             *
             * @param newVal
             * @param oldVal
             */
            data(newVal, oldVal) {
                this.$refs.vuetable.refresh();
            },
            /**
             * Rafraichit la table si les données changent
             *
             * @param newVal
             * @param oldVal
             */
            fields(newVal, oldVal) {
                this.$refs.vuetable.refresh();
            },
            /**
             * Rafraichit la table si les données changent
             *
             * @param newVal
             * @param oldVal
             */
            perPage(newVal, oldVal) {
                this.$refs.vuetable.refresh();
            },
        },
    }
</script>


// WEBPACK FOOTER //
// resources/js/components/layout/Datatable.vue